const BrowserIDService = (() => {
  const LOCAL_STORAGE_KEY = 'fallback_guid';

  function openDatabase() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('GUIDDatabase', 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('GUIDStore')) {
          db.createObjectStore('GUIDStore', { keyPath: 'id' });
        }
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onerror = (event) => {
        reject(event.target.error);
      };
    });
  }

  async function storeGUID(guid) {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, guid);
      const db = await openDatabase();
      return new Promise((resolve, reject) => {
        const transaction = db.transaction('GUIDStore', 'readwrite');
        const store = transaction.objectStore('GUIDStore');
        const request = store.put({ id: 'guid', value: guid });

        request.onsuccess = () => {
          resolve();
        };

        request.onerror = (event) => {
          console.warn('IndexedDB storeGUID error:', event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.warn('IndexedDB storeGUID exception:', error);
      // Fallback to localStorage
      // localStorage.setItem(LOCAL_STORAGE_KEY, guid);
    }
  }

  async function getGUID() {
    try {
      const db = await openDatabase();
      return new Promise((resolve, reject) => {
        const transaction = db.transaction('GUIDStore', 'readonly');
        const store = transaction.objectStore('GUIDStore');
        const request = store.get('guid');

        request.onsuccess = (event) => {
          resolve(event.target.result?.value || null);
        };

        request.onerror = (event) => {
          console.warn('IndexedDB getGUID error:', event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.warn('IndexedDB getGUID exception:', error);
      // Fallback to localStorage
      return localStorage.getItem(LOCAL_STORAGE_KEY);
    }
  }

  function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = (Math.random() * 16) | 0;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  async function getBrowserId() {
    let guid = null;
    try {
      guid = await getGUID();
      
    } catch (e) {
      console.warn('Failed to get GUID from IndexedDB:', e);
    }
    // console.log(guid);

    if (!guid) {
      guid = localStorage.getItem(LOCAL_STORAGE_KEY);
      await storeGUID(guid)
    }else{
      localStorage.setItem(LOCAL_STORAGE_KEY, guid);
    }

    if (!guid) {
      guid = generateGUID();
      await storeGUID(guid); // Attempts IndexedDB first, then localStorage fallback
    }

    return guid;
  }

  return {
    getBrowserId,
  };
})();

export default BrowserIDService;


// const LOCAL_STORAGE_KEY = 'fallback_guid';

// // GUID generator
// function generateGUID() {
//   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
//     const random = (Math.random() * 16) | 0;
//     const value = char === 'x' ? random : (random & 0x3) | 0x8;
//     return value.toString(16);
//   });
// }

// // One-time migration from IndexedDB to localStorage
// async function migrateGUIDToLocalStorage() {
//   if (localStorage.getItem(LOCAL_STORAGE_KEY)) return;

//   try {
//     const request = indexedDB.open('GUIDDatabase', 1);

//     request.onsuccess = (event) => {
//       const db = event.target.result;
//       const transaction = db.transaction('GUIDStore', 'readonly');
//       const store = transaction.objectStore('GUIDStore');
//       const getRequest = store.get('guid');

//       getRequest.onsuccess = (event) => {
//         const result = event.target.result;
//         if (result?.value) {
//           localStorage.setItem(LOCAL_STORAGE_KEY, result.value);
//           console.log('[Migration] GUID migrated to localStorage:', result.value);

//           // Optional: Remove from IndexedDB
//           const deleteTx = db.transaction('GUIDStore', 'readwrite');
//           const deleteStore = deleteTx.objectStore('GUIDStore');
//           deleteStore.delete('guid');
//         }
//       };

//       getRequest.onerror = (event) => {
//         console.warn('[Migration] Failed to read from IndexedDB:', event.target.error);
//       };
//     };

//     request.onerror = (event) => {
//       console.warn('[Migration] Failed to open IndexedDB:', event.target.error);
//     };
//   } catch (error) {
//     console.warn('[Migration] Exception during migration:', error);
//   }
// }

// // Public API
// const BrowserIDService = {
//   async getBrowserId() {
//     let guid = localStorage.getItem(LOCAL_STORAGE_KEY);
//     if (!guid) {
//       guid = generateGUID();
//       localStorage.setItem(LOCAL_STORAGE_KEY, guid);
//       console.log('[BrowserIDService] New GUID generated and stored:', guid);
//     } else {
//       console.log('[BrowserIDService] Existing GUID loaded:', guid);
//     }
//     return guid;
//   },

//   migrateGUIDToLocalStorage,
// };

// export default BrowserIDService;

